export enum DocumentTypeEnum {
  DNI = 'DNI',
  RUC = 'RUC',
  CE = 'CE',
  PASSPORT = 'PASSPORT',
  OTRO = 'OTRO',
}
export const documentCodeToEnum = (code: string): string => {
  switch (code) {
    case '01':
      return DocumentTypeEnum.DNI;
    case '04':
      return DocumentTypeEnum.CE;
    case '07':
      return DocumentTypeEnum.PASSPORT;
    case '06':
      return DocumentTypeEnum.RUC;
    case '00':
      return DocumentTypeEnum.OTRO;
    default:
      return code; 
  }
};
export const enumToDocumentCode = (docType: string): string => {
  switch (docType) {
    case DocumentTypeEnum.DNI:
      return '01';
    case DocumentTypeEnum.CE:
      return '04';
    case DocumentTypeEnum.PASSPORT:
      return '07';
    case DocumentTypeEnum.RUC:
      return '06';
    case DocumentTypeEnum.OTRO:
      return '00';
    default:
      return docType; 
  }
};
export const documentTypeDescriptions: Record<string, string> = {
  DNI: 'DNI',
  CE: 'C. de extranjería',
  PASSPORT: 'Pasaporte',
  RUC: 'RUC',
  OTRO: 'Otro',
}